import type { ComponentType } from 'react';

import { BookOpenIcon, ClipboardCheckIcon, ClipboardIcon, ClipboardListIcon, FileTextIcon, FolderIcon, StarIcon } from '../layout/icons';

export interface HomeNavItem {
  id: string;
  label: string;
  // Caption for the collapsed icon rail, which has ~72px to play with. Omitted where the full
  // label already fits. The full label stays the accessible name either way.
  shortLabel?: string;
  icon: ComponentType<{ size?: number }>;
  // Route the item points at, or null while the screen does not exist - a null item renders
  // disabled rather than shipping a clickable dead end.
  route: string | null;
}

export interface HomeNavGroup {
  label: string;
  items: HomeNavItem[];
}

export const LECTURE_LIBRARY_ROUTE = '/kho-bai-giang';
export const QUESTION_BANK_ROUTE = '/kho-bai-tap';
export const CONDUCT_ROUTE = '/khen-thuong-ki-luat';
export const ATTENDANCE_ROUTE = '/diem-danh';
export const COURSES_ROUTE = '/khoa-hoc';
export const DOCUMENT_LIBRARY_ROUTE = '/kho-tai-lieu';

// Labels are the design's typed strings; home.css applies the uppercase Figma sets via textCase.
export const HOME_NAV: HomeNavGroup[] = [
  {
    label: 'Bài giảng',
    items: [
      { id: 'lecture-library', label: 'Kho bài giảng', shortLabel: 'Bài giảng', icon: FolderIcon, route: LECTURE_LIBRARY_ROUTE },
      { id: 'question-bank', label: 'Kho bài tập', shortLabel: 'Bài tập', icon: ClipboardIcon, route: QUESTION_BANK_ROUTE },
      { id: 'document-library', label: 'Kho tài liệu', shortLabel: 'Tài liệu', icon: FileTextIcon, route: DOCUMENT_LIBRARY_ROUTE },
      { id: 'sample-library', label: 'Kho bài mẫu', shortLabel: 'Bài mẫu', icon: ClipboardListIcon, route: null },
      { id: 'courses', label: 'Khoá học', icon: BookOpenIcon, route: COURSES_ROUTE },
    ],
  },
  {
    label: 'Quản lý lớp',
    items: [
      { id: 'attendance', label: 'Điểm danh', icon: ClipboardCheckIcon, route: ATTENDANCE_ROUTE },
      { id: 'conduct', label: 'Khen thưởng - Kỉ luật', shortLabel: 'Khen thưởng', icon: StarIcon, route: CONDUCT_ROUTE },
    ],
  },
];

// Customer-facing wording: the screen is on the roadmap, not broken or withheld.
export const NAV_COMING_SOON = 'Tính năng sắp ra mắt';

export interface HomeNavReleasedItem extends HomeNavItem {
  route: string;
}

export interface HomeNavReleasedGroup {
  label: string;
  items: HomeNavReleasedItem[];
}

// Kept for non-demo builds; the demo sidebar renders HOME_NAV whole so the menu shows the full surface.
export function releasedNavGroups(): HomeNavReleasedGroup[] {
  const groups: HomeNavReleasedGroup[] = [];
  HOME_NAV.forEach((group) => {
    const items: HomeNavReleasedItem[] = [];
    group.items.forEach((item) => { if (item.route !== null) items.push({ ...item, route: item.route }); });
    if (items.length > 0) groups.push({ label: group.label, items: items });
  });
  return groups;
}
